import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select as AntSelect, Divider, Button as AntButton } from 'antd';
import moment from 'moment';
import { saveTransferDoc } from '../../reducers/transfer/TransferActions';
import '../CreateAccountWizard/createAccount.css';
import '../WiringInstruction/WiringInstruction.css';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Typography,
  Modal,
  Backdrop,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import copy from '../../styles/assets/content_copy.png';
import handCross from '../../styles/assets/hand-cross.png';
import handFinger from '../../styles/assets/One.png';
import expireCalender from '../../styles/assets/expired.png';
import indeaMessage from '../../styles/assets/private chat.png';
import { Container, Row, Col } from 'react-bootstrap';
import BoxContainerWiring from '../BoxContainer/BoxContainerWiring';
import close from '../../styles/assets/close.png';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import AlertBanner from '../AlertBanner';
import { ToastContainer, toast } from 'react-toastify';
import { useTransfer } from '../../utils/service/service_transfer_api';
import 'react-toastify/dist/ReactToastify.css';
import { useAllTenants } from '../../utils/service/service_tenant_api';
import css from '../../styles/modules/WiringInstructions/wiringinstruction.module.css';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import {
  clearLoading,
  setLoading,
} from '../../reducers/utility/utilityActions';
import addBusinessDays from './lib/addBusinessDays';
import LockAvatar from './components/LockAvatar';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import phoneFormatter from '../../utils/service/phoneFormatter';
import formatPhoneNumber from '../../utils/service/formatPhoneNumber';
import SendMoney from '../SendMoney/SendMoney';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';

const Title = () => (
  <div className="create-account__line-container">
    <div className="create-account__title"></div>
  </div>
);
const getTransferDetails = async () => {
  let response = await axios({
    url: `${process.env.REACT_APP_BASE_SERVICE_URL}/account/microdeposit/link-token`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
    },
  });
};

// React.useEffect( () => {
//   getTransferDetails()
// },[])

// const showToastMessage = () => {
//   toast.success('Success Notification !', {
//       position: toast.POSITION.TOP_RIGHT
//   });
// };

const InfoTransfer = ({ handleGoBack, handleGoNext }) => (
  <>
    <MainText
      text={'Congratulations, below are your secure wiring instructions.'}
    />
    {/* <SecondaryText
      text={
        'This information is just for you and is valid for only one wire transfer.'
      }
    /> */}
  </>
);

const MainText = ({ text }) => (
  <div style={{ marginTop: '1px' }} className={css.mainText}>
    {text}
  </div>
);

const ModalContent = ({ sign, textH5, textP1, textP2 }) => (
  <div className="d-flex mt-4">
    <div className="prevent-fraud text-center">
      <figure>
        <img src={sign} />
      </figure>
      <h5>{textH5}</h5>
      <p>{textP1}</p>
    </div>
    <div className="detail-text pl-4">
      <h6>{textH5}</h6>
      <p>{textP2}</p>
    </div>
  </div>
);

const DoYourPartContent = ({
  image,
  textH5,
  textP1,
  handleLearnMore,
  handleClose,
  showModal,
  index,
}) => (
  <div className="prevent-fraud text-center">
    <figure>
      <img src={image} />
    </figure>
    <h5>{textH5}</h5>
    <p>{textP1}</p>
    <>
      <a
        style={{ marginTop: 'auto' }}
        onClick={handleLearnMore}
        className="link"
      >
        Learn more
      </a>
      <CustomModal handleClose={handleClose} openModal={showModal} />
    </>
  </div>
);

const useStyles = makeStyles((theme) => ({
  card: {},
  logo: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: theme.palette.secondary.main,
  },
}));

const CustomModal = ({ openModal, handleClose }) => {
  const modalContent = [
    {
      sign: handCross,
      textH5: 'Use the right method.',
      textP1: 'Do NOT send an ACH payment. It will be rejected.',
      textP2: `It is essential to use the correct payment method when performing wire transfers. Do not use ACH payments for wire transfers, as they will be rejected. ACH transfers and wire transfers are not the same. This bank account is blocked from accepting incoming ACH payments. Please ensure you're making a wire transfer to avoid any disruptions in the closing process.`,
    },
    {
      sign: expireCalender,
      textH5: 'Use only once.',
      textP1:
        'The information we are about to share is valid for a one-time wire transfer.',
      textP2: `The wiring instructions we provide to you are valid for a single transfer only. This measure is to ensure maximum security and to prevent any potential misuse or fraudulent activity. After the transaction is complete, these wiring instructions become invalid. Therefore, every time you need to make a wire transfer, you will have to log in for new wiring instructions.`,
    },
    {
      sign: indeaMessage,
      textH5: 'Watch the date.',
      textP1:
        'This information expires. If you need more time, log back in for an extension.',
      textP2: `Keep a close eye on the expiration date of these wiring instructions. For your safety, the details provided in the wiring instructions come with an expiration date. This feature is designed to prevent long-term vulnerabilities that might be exploited over time. If you need an extension, you must log back and generate new wiring instructions.`,
    },
    {
      sign: handCross,
      textH5: 'Keep private.',
      textP1:
        'This information is unique to you. Please don’t share it with anyone else.',
      textP2: `The wire instructions provided to you are unique and confidential. Treat it like your ATM Card PIN; never share it with anyone else. Your title/escrow company will never ask you for these wiring instructions. By keeping this information private, you protect yourself against potential fraud attempts.`,
    },
  ];
  return (
    <div>
      <Modal
        className="prevent-fraud-modal"
        open={openModal}
        onClose={openModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ onClick: handleClose }}
      >
        <div className={css.modalContent}>
          <div className={css.modalContentInner}>
            <div className="header-modal">
              <h3>Do your part to prevent fraud.</h3>
              <span onClick={handleClose}>
                <img src={close} />
              </span>
            </div>
            <div className="modal-body-content">
              {modalContent.map((content) => (
                <ModalContent
                  sign={content.sign}
                  textH5={content.textH5}
                  textP1={content.textP1}
                  textP2={content.textP2}
                />
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const MaterialUICard = ({
  handleGoBack,
  handleGoNext,
  detail,
  transfer_detail,
  rest,
}) => {
  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(true);
  const alertBannerText = () => {
    return `Text Copiend!`;
  };

  const width = useWindowWidth();

  // controls the loading state for placeholder loading effect
  useEffect(() => {
    if (detail?.accountNumber) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [detail]);

  /**
   * @function
   */
  const alertBannerShouldBeVisible = () => {
    return showBanner;
  };
  const copyText = (refId) => {
    const paragraphText = document.getElementById(refId).innerText;
    navigator.clipboard
      .writeText(paragraphText)
      .then(() => {
        toast.success('Text Copied!', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-custom',
          bodyClassName: 'toast-content-custom',
        });
      })
      .catch((error) => {
        console.error('Error copying text:', error);
      });
  };
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };
  const handleLearnMore = () => {
    setShowModal(true);
  };

  let contents = [
    {
      image: handCross,
      textH5: 'Use the right method.',
      textP1: 'Do NOT send an ACH payment. It will be rejected.',
    },
    {
      image: handFinger,
      textH5: 'Use only once.',
      textP1:
        'The information we are about to share is valid for a one-time wire transfer.',
    },
    {
      image: expireCalender,
      textH5: 'Watch the date.',
      textP1:
        'This information expires. If you need more time, log back in for an extension.',
    },
    {
      image: indeaMessage,
      textH5: 'Keep private.',
      textP1:
        'This information is unique to you. Please don’t share it with anyone else.',
    },
  ];

  return (
    <Fragment>
      <Card className="wrining-instruction-card">
        <div className="card-header-head">
          <div>
            <h2>Secure Wiring Instructions</h2>
          </div>
          {/* <div style={{ display: 'flex' }}>
            <p style={{ marginRight: '20px' }}>{`EXPIRATION DATE `}</p>
            <p>
              {!loading ? (
                moment(detail?.expirationDate).format('MMMM, DD YYYY')
              ) : (
                <SkeletonLoader width="130px" height="20px" />
              )}
            </p>
          </div> */}
          <LockAvatar />
        </div>
        <CardContent className="secure-card">
          <div
            style={{ backgroundColor: 'rgba(2,36,61,.07)' }}
            className={css.instructionTableRow}
          >
            <div className={css.tableDesc}>
              <h4 className="grey-text">BANK DETAILS</h4>
            </div>

            {loading ? (
              <div className={css.tableDataEntry}>
                <SkeletonLoader width="130px" height="20px" />
                <SkeletonLoader width="130px" height="20px" />
                <SkeletonLoader width="130px" height="20px" />
              </div>
            ) : (
              <div className={css.tableDataEntry}>
                <p style={{ marginBottom: '0px' }}>{detail?.bankName}</p>
                <p style={{ width: '150px' }}>{detail?.bankAddress}</p>
              </div>
            )}
          </div>
          <div className={css.instructionTableRow}>
            <div className={css.tableDesc}>
              <h4 className="grey-text">ROUTING NUMBER</h4>
            </div>
            <div className={css.tableDataEntry}>
              <p className="mb-0" id="routingNumber">
                {loading ? (
                  <SkeletonLoader width="130px" height="20px" />
                ) : (
                  detail?.routingNumber
                )}
                <button
                  className={css.copyBtnWhite}
                  onClick={() => copyText('routingNumber')}
                >
                  {!loading ? <img src={copy} /> : null}
                </button>
              </p>
              <ToastContainer />
            </div>
          </div>
          <div
            style={{ backgroundColor: 'rgba(2,36,61,.07)' }}
            className={css.instructionTableRow}
          >
            <div className={css.tableDesc}>
              <h4 className="grey-text">ACCOUNT NUMBER</h4>
            </div>
            <div className={css.tableDataEntry}>
              <p className="mb-0" id="accountNumber">
                {loading ? (
                  <SkeletonLoader width="130px" height="20px" />
                ) : (
                  detail?.accountNumber
                )}
                <button
                  className={css.copyBtnGrey}
                  onClick={() => copyText('accountNumber')}
                >
                  {!loading ? <img src={copy} /> : null}
                </button>
              </p>
            </div>
          </div>
          <div className={css.instructionTableRow}>
            <div className={css.tableDesc}>
              <h4 className="grey-text">BENEFICIARY DETAILS</h4>
            </div>
            <div className={css.tableDataEntry}>
              {loading ? (
                <SkeletonLoader width="130px" height="20px" />
              ) : (
                <>
                  <p style={{ marginBottom: '0px' }}>
                    {detail?.beneficiaryName}
                  </p>
                  <p style={{ width: '150px' }}>{detail?.beneficiaryAddress}</p>
                </>
              )}
            </div>
          </div>
          <div
            style={{ backgroundColor: 'rgba(2,36,61,.07)' }}
            className={css.instructionTableRow}
          >
            <div className={css.tableDesc}>
              <h4 className="grey-text">PHONE NUMBER</h4>
            </div>
            <div className={css.tableDataEntry}>
              <p className="mb-0">
                {' '}
                {loading ? (
                  <SkeletonLoader width="130px" height="20px" />
                ) : (
                  detail?.beneficiaryPhone &&
                  formatPhoneNumber(detail?.beneficiaryPhone)
                )}
              </p>
            </div>
          </div>
          <div className={css.instructionTableRow}>
            <div className={css.tableDesc}>
              <h4 className="grey-text">AMOUNT TO TRANSFER</h4>
            </div>
            <div className={css.tableDataEntry}>
              <p className="mb-0">
                {loading ? (
                  <SkeletonLoader width="130px" height="20px" />
                ) : (
                  `$${parseFloat(transfer_detail?.amount).toLocaleString(
                    'en-US',
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )}`
                )}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className={css.pictureWrapper}>
        <SendMoney {...rest} />
        {/* <div className={css.pictureSubWrapper}>
          <h3 className="grey-text text-center pt-4 pb-4">
            Do your part to prevent fraud.
          </h3>
          <div className="d-flex mb-5 pictureContainer">
            {contents.map((content, index) => (
              <DoYourPartContent
                image={content.image}
                textH5={content.textH5}
                textP1={content.textP1}
                handleLearnMore={handleLearnMore}
                handleClose={handleClose}
                showModal={showModal}
                index={index}
              />
            ))}
          </div>
        </div> */}
      </div>

      <div className={css.lineContainer}>
        <AntButton
          onClick={handleGoBack}
          className={css.buttonLeft}
          variant="contained"
        >
          Back
        </AntButton>
        <hr className={css.hr} />
        <AntButton
          onClick={handleGoNext}
          className={css.buttonRight}
          variant="contained"
        >
          Done
        </AntButton>
      </div>
    </Fragment>
  );
};

const SecondaryText = ({ text }) => (
  <div
    style={{
      marginTop: '20px',
      fontFamily: 'Lato',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '24px',
      textAlign: 'center',
      color: '#79747E',
    }}
  >
    This information is <b>just for you</b> and is valid for{' '}
    <b>only one wire transfer</b> .
  </div>
);
const WiringInstruction = (props) => {
  const [detail, setDetail] = useState(null);
  const history = useHistory();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const transfer_id = queryParams.get('transfer_id');
  const tenant_id = queryParams.get('tenant_id');
  const { refetchTransfer, transfer } = useTransfer(transfer_id);
  const fromLocation = history?.location?.state?.fromLocation;
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state).utility;

  useEffect(() => {
    dispatch(clearLoading());
  }, []);

  //scrolls page to top
  useEffect(() => {
    setTimeout(() => {
      document.querySelector('html').scrollTo(0, 0);
      document.querySelector('body').scrollTo(0, 0);
    }, 1);
  }, []);

  /* 
    To avoid that a user creates a second wire, the function below
    intercepts the back button and redirects the user to the transfer-history
    page where the transfer can be found and the wire instructions can be retrieved
  */

  // Event listener for back button
  useEffect(() => {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function (event) {
      window.history.pushState(null, '', window.location.href);
      handleBackButtonEvent();
    };
  }, []);

  const handleBackButtonEvent = () => {
    //if user is coming from Tranfer-history
    if (fromLocation === 'OUTBOUND_TRANSFER') {
      dispatch(setLoading());
      //need set timeout to render the spinner
      setTimeout(() => {
        return history.push('/transfer-history');
      }, 100);
      //empty return needed to avoid else block
      return;
    } else {
      //if user is coming from wire flow
      history.push(
        `/create-account/step-3?transfer_id=${transfer_id}&tenant_id=${tenant_id}`,
      );
    }
  };

  const handleGoBack = () => {
    history.push('/create-account/step-3', { existingTransferId: transfer_id });
  };

  const handleGoNext = () => {
    if (!isLoading) {
      dispatch(setLoading());
      setTimeout(() => {
        props.history.push('/transfer-history');
        window.location.reload();
      }, 100);
    }
  };

  const getDetail = async (tenant_id, transfer_id) => {
    const response = await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BASE_SERVICE_URL}/wallet/wire/client-account/${tenant_id}/${transfer_id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_AUTH_TOKEN}`,
      },
    });
    setDetail(response?.data);
    return response;
  };

  useEffect(() => {
    getDetail(tenant_id, transfer_id);
  }, [transfer_id, tenant_id]);

  return (
    <BoxContainerWiring
      tenantName={props && props.tenant && props.tenant.name}
      withDoubleBorder
      withLogButton
      detail={detail}
      transfer_detail={transfer}
      widest
    >
      {isLoading ? <SpinnerLoader /> : null}
      <Title />
      <InfoTransfer handleGoBack={handleGoBack} handleGoNext={handleGoNext} />

      <MaterialUICard
        handleGoBack={handleGoBack}
        handleGoNext={handleGoNext}
        detail={detail}
        transfer_detail={transfer}
        rest={{ ...props }}
      />
    </BoxContainerWiring>
  );
};

export default withRouter(
  connect((state) => ({}), {
    onSaveTransferDoc: saveTransferDoc,
  })(WiringInstruction),
);
